import Modal from 'react-modal';

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(0,0,0, 0.5)',
        zIndex: 1000,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'none',
        inset: 'none',
        borderRadius: 'none',
        border: 0,
        background: 'none',
    },
};

const ModifierDialog = ({isOpen, modifiers, selectedModifiers, onSelectionChange, onClose}) => {

    return (
        <Modal
            style={customStyles}
            isOpen={isOpen}>
            <div className="dialogbox show">
                <div className="modal-dialog">
                    <div className="modal-content card-border">
                        <div className="modal-icon" style={{fontSize: '18px', marginBottom: 0, marginTop: '16px'}}>
                            Modifier
                        </div>
                        <div className="modal-body listing mt-2">
                            {
                                modifiers.map(modifier => {
                                    const isChecked = selectedModifiers.find(m => m.modifierId === modifier.modifierId);
                                    return (
                                        <div key={modifier.modifierId} className="form-check"
                                             style={{margin: '16px 0', display: 'flex'}}>
                                            <input
                                                type={"checkbox"}
                                                id={`modifier-checkbox-${modifier.modifierId}`}
                                                checked={!!isChecked}
                                                onChange={(e) => onSelectionChange(e.target.checked, modifier)}
                                                className="form-check-input"
                                            />
                                            <label
                                                className={`form-check-label checkbox`}
                                                style={{flex: 1}}
                                                htmlFor={`modifier-checkbox-${modifier.modifierId}`}>{modifier.name}</label>
                                            <div>
                                                {modifier.selectionAllowed}
                                            </div>
                                        </div>

                                    )
                                })
                            }
                        </div>
                        <div className="modal-footer">
                            <div onClick={onClose} className="btn-inline">
                                <a className="btn">Close</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModifierDialog;
